import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import ContentState from '../../../../stores/ContentState'
import { NumberCountWrapper } from '../../../common/NumberCount'
import Parallax from '../../../common/Parallax'
import Shop from '../Shop'
import './index.scss'
const Solutions = observer(() => {
  const [solution, setSolution] = useState('')
  useEffect(() => {
    if (ContentState.about?.we.solutions && !solution.length) {
      if (!ContentState.about?.we.solutions.list.length) return
      setSolution(ContentState.about?.we.solutions.list[0].title)
    }
  }, [ContentState.about?.we.solutions])

  if (!ContentState.about) return <></>

  return (
    <div className="we-block__solutions">
      <div className="we-block__solutions-container">
        <div style={{ overflow: 'hidden' }}>
          <div
            className="we-block__solutions-title"
            dangerouslySetInnerHTML={{
              __html: ContentState.about.we.solutions.title,
            }}
          ></div>
        </div>
        <div className="we-block__solutions-tabs">
          {ContentState.about.we.solutions.list.map((s, i) => (
            <SolutionTab
              title={s.title}
              key={i}
              active={solution == s.title}
              setTab={(value) => setSolution(value)}
            />
          ))}
        </div>
        <div className="we-block__solutions-list">
          {ContentState.about.we.solutions.list.map((s, i) => (
            <div
              className={classNames(
                'we-block__solutions-item',
                solution == s.title && 'active',
              )}
              key={i}
            >
              <div className="we-block__solutions-img">
                <Parallax
                  src={s.video ? s.video! : s.src!}
                  type={s.video ? 'video' : 'img'}
                  poster={s.video ? s.src : ''}
                />
              </div>
              <div className="we-block__solutions-info">
                <div
                  className="we-block__solutions-text"
                  dangerouslySetInnerHTML={{ __html: s.text }}
                ></div>
                <div className="we-block__list">
                  {s.numbers.map((l, i) => (
                    <div className="we-block__item" key={i}>
                      <div className="we-block__item-num">
                        <NumberCountWrapper final={+l.num} end={l.end} />
                      </div>
                      <div
                        className={classNames('we-block__item-text')}
                        dangerouslySetInnerHTML={{ __html: l.text }}
                      ></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        <Shop />
      </div>
    </div>
  )
})

export default Solutions
export const SolutionTab = observer(
  ({
    title,
    active,
    setTab,
  }: {
    title: string
    active: boolean
    setTab: (value: string) => void
  }) => {
    return (
      <div
        className={classNames('we-block__solutions-tab', active && 'active')}
        onClick={() => setTab(title)}
      >
        <span> {title}</span>
      </div>
    )
  },
)
